import React, { useContext, useState } from "react";

import InnerLayout from "../../components/layouts/inner-layout";
import { DataContext } from "../../components/layouts/main-layout";
import StoreCreateViewEdit from "../../components/store-information/create-edit-view-store";
import AccessDenied from "../../components/helper-components/access-denied";

const AddStore = () => {
  const { permissionFn } = useContext(DataContext);
  // Same access check as Price List: the page needs "create" on
  // document and shows AccessDenied without it.
  const hasAccess = permissionFn("document")?.create === true;
  const [storeData, setStoreData] = useState({
    address: {},
    personal: {},
    firm: {},
    agreement: {},
    payment: {},
    drug: {},
  });
  if (!hasAccess) {
    return (
      <InnerLayout title="Store Information" backBtn={true}>
        <AccessDenied message="You don't have permission to create Store Information." />
      </InnerLayout>
    );
  }

  return (
    <InnerLayout onclkFn={"/add-store"} title="Store Information" backBtn={true}>
      <StoreCreateViewEdit setStoreData={setStoreData} storeData={storeData} />
    </InnerLayout>
  );
};

export default AddStore;
